export const OPEN_DIALOG = "OPEN_DIALOG"
export const CLOSE_DIALOG = "CLOSE_DIALOG"

const INITIAL_STATE = {
  addDialogOpen: false,
  template: null,
}

export default function reportsReducer(
  state = INITIAL_STATE,
  { type, payload }
) {
  switch (type) {
    case OPEN_DIALOG:
      return {
        ...state,
        addDialogOpen: true,
        template: payload,
      }

    case CLOSE_DIALOG:
      return {
        ...state,
        addDialogOpen: false,
        template: null,
      }
    default:
      return state
  }
}

export function openDialog(payload) {
  return {
    type: OPEN_DIALOG,
    payload,
  }
}

export function closeDialog() {
  return {
    type: CLOSE_DIALOG,
  }
}
